export default __webpack_public_path__ + "static/media/ghost.6adc3d6d.svg";